import { render, staticRenderFns } from "./AddFundPage.vue?vue&type=template&id=a8b6a2a4&"
import script from "./AddFundPage.vue?vue&type=script&lang=ts&"
export * from "./AddFundPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddFundPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports